import { popinOptinConstants } from "../../../../constants";
import { getRootUrl } from '../../../../utils';
export const fetchUserData = async (abortController, getErrorMessage, onSuccess, onError) => {
    const endpointUrl = `${getRootUrl()}/${popinOptinConstants.url.getSubscriptionUrl}`;
    try {
        const response = await fetch(endpointUrl, {
            signal: abortController.signal,
            credentials: 'include',
        });
        if (!response.ok) {
            onError(`Error: ${response.status} ${response.statusText}`);
            return;
        }
        const data = await response.json();
        onSuccess(data);
    }
    catch (err) {
        if (err instanceof Error && err.name === 'AbortError') {
            return;
        }
        const errorMessage = getErrorMessage || (err instanceof Error ? err.message : 'An unknown error occurred while fetching user data.');
        onError(errorMessage);
    }
};
